import { useNotifier } from '@provider/notifier';
import { useTrackingManager } from '@provider/tracking';
import { Tooltip, Button } from '@ui/kit';
import { PublisherLogo, HeartIcon } from '@ui/kit/icons';
import { PostloadedImage } from '@utils/react';
import { useToggleFavouriteMutation } from '../api/toggle-favourite.mutation.js';
import { graphic, overflowContainer, publisher, banner, heartButton } from './atom.graphic.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function CardGraphic(props) {
  const tracker = useTrackingManager();
  const notifier = useNotifier();
  const {
    addMutation,
    deleteMutation
  } = useToggleFavouriteMutation(props.descriptor);
  const handleDelete = async () => {
    const trackingContext = {
      context: "favourite-card",
      targetId: props.descriptor.type === "course" ? props.descriptor.courseId : props.descriptor.pageId,
      targetType: props.descriptor.type === "course" ? "Course" : "Page",
      targetPath: props.favourite?.path ?? "",
      targetTitle: props.favourite?.title ?? ""
    };
    await deleteMutation.mutateAsync();
    tracker.trackEvent("userarea.favourites.delete", trackingContext);
    notifier.notify({
      id: "user-area/favourites/card/undo-delete",
      type: "success",
      dismissOnInteractableContentClick: true,
      body: /*#__PURE__*/jsxs("div", {
        children: ["Favoritten ", /*#__PURE__*/jsxs("b", {
          children: ["\u2018", props.favourite?.title, "\u2019"]
        }), " er fjernet", /*#__PURE__*/jsx(Button, {
          style: {
            marginTop: 6
          },
          onClick: () => {
            addMutation.mutate();
            tracker.trackEvent("userarea.favourites.add", trackingContext);
          },
          theme: "tertiary",
          children: "Fortryd"
        })]
      })
    });
  };
  return /*#__PURE__*/jsxs("div", {
    className: graphic,
    children: [/*#__PURE__*/jsxs("div", {
      className: overflowContainer,
      children: [!!props.favourite?.vignette && /*#__PURE__*/jsx(PostloadedImage, {
        src: props.favourite.vignette.url,
        alt: props.favourite.vignette.alt ?? "",
        width: props.favourite.vignette.width,
        height: props.favourite.vignette.height,
        sizes: "160px"
      }), /*#__PURE__*/jsx(PublisherLogo, {
        small: true,
        className: publisher
      })]
    }), props.favourite?.type === "course" && props.favourite.revisionId && /*#__PURE__*/jsx("span", {
      className: banner,
      children: "Version"
    }), props.favourite && /*#__PURE__*/jsx(Tooltip, {
      ariaType: "label",
      placement: "top",
      body: "Fjern fra favoritter",
      children: ref => /*#__PURE__*/jsx("button", {
        ref: ref,
        className: heartButton,
        onClick: handleDelete,
        children: /*#__PURE__*/jsx(HeartIcon, {})
      })
    })]
  });
}

export { CardGraphic };
//# sourceMappingURL=atom.graphic.js.map
